import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DeliveryTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-delivery-type',
  templateUrl: './delivery-type.component.html',
  styleUrls: ['./delivery-type.component.scss']
})
export class DeliveryTypeComponent implements OnChanges {

  deliverytypeForm: FormGroup;
  deliverytypeFormArray: FormGroup;
  control = new FormControl();
  @Input() deliverytypes: DeliveryTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() deliverytype = new EventEmitter<DeliveryTypeDto[]>()
  @Output() deleteDeliveryTypeEvent = new EventEmitter<any>()

    selectedDeliveryType: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createDeliveryTypeForm();
    }

    createDeliveryTypeForm() {
      this.deliverytypeForm = this.fb.group({
        DeliveryTypeName: ['', Validators.required],
        id: null
        });
        this.deliverytypeFormArray = this.fb.group({ DeliveryTypes: this.fb.array([])
          });
        this.setDeliveryType();
    }

  // method to display deliverytypes
  setDeliveryType() {
    const control  = this.deliverytypeFormArray.controls.DeliveryTypes as FormArray;
    this.deliverytypes.forEach( e => {
      control.push(
        this.fb.group({
          DeliveryTypeName: e.DeliveryTypeName,
          id: e.id
        })
      );
    });
  }


  // method to add DeliveryType
  addDeliveryType(value: DeliveryTypeDto) {
    const control  = this.deliverytypeFormArray.controls.DeliveryTypes as FormArray;
    control.insert(0,
          this.fb.group({
            DeliveryTypeName: value.DeliveryTypeName,
            id: null
          })
       );
  }

  selectDeliveryType(value) {}

  // method to delete deliverytype from arrary list
  deleteDeliveryType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.deliverytypeFormArray.controls.DeliveryTypes as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.deliverytypes.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.deliverytypes[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: DeliveryTypeDto) {
    if(this.deliverytypeForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.deliverytypeFormArray.get('DeliveryTypes')['controls'][this.selectedIndex].patchValue({DeliveryTypeName: formValue.DeliveryTypeName});
    } else {
      this.addDeliveryType(formValue);
    }
    this.selectedIndex = null;
    this.deliverytypeForm.reset()
  }

  onEdit(index, value: DeliveryTypeDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.deliverytypeForm.patchValue({DeliveryTypeName: value.DeliveryTypeName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.deliverytypeForm.reset();
  }

  onSubmit(formValue: DeliveryTypeDto[]) {
  this.deliverytype.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteDeliveryTypeEvent.emit(this.filteredDelete);
  }
  }

}
